import React, { useContext } from 'react';
import { isEmpty, get } from 'lodash';
import { ApplicationName, FormNavigation } from 'components/CASAForm';
import {
  AuFormItemWrapper,
  AuDirectionLink,
  AuErrorText,
  CasaDeclaration
} from 'components/DTA';
import { ArnContext, FormContext } from 'contexts';
import { useFormikContext } from 'formik';
import { PoiVerificationApplicationFormData } from 'types/forms/arnApplicationTypes';
import { Loader } from 'components/common';
import { FORM_VALIDATION_ERROR_ALERT } from 'arnConstants';

const DeclarationAndSubmitPoi: React.FC = () => {
  const { validateForm, submitForm, isSubmitting, errors } = useFormikContext<PoiVerificationApplicationFormData>();
  const { previousStep } = useContext(ArnContext);
  const { setFormAlert, openStepById, handleBack, setOnChangeValidation } = useContext(FormContext);
  const declarationFieldError = get(errors, 'declaration');

  const handleBackAction = () => {
    if (previousStep) {
      openStepById(previousStep);
      return;
    }
    handleBack();
  };

  const submitPoiApplication = async () => {
    const validationErrors = await validateForm();

    if (!validationErrors || isEmpty(validationErrors)) {
      setFormAlert(null);
      setOnChangeValidation(false);
      submitForm();
    }
    else {
      setFormAlert(FORM_VALIDATION_ERROR_ALERT);
      setOnChangeValidation(true);
    }
  };

  if (isSubmitting) {
    return (<Loader />);
  }

  return (
    <>
      <ApplicationName name='Declaration' />
      <AuDirectionLink
        onClick={handleBackAction}
        text="Back"
        direction="left" />
      <AuFormItemWrapper>
        <CasaDeclaration id='declaration'></CasaDeclaration>
        {declarationFieldError && <AuErrorText text={declarationFieldError} />}
      </AuFormItemWrapper>
      <FormNavigation nextButtonText='Submit application' onNextAction={submitPoiApplication} hidePrevious showSaveAndExit={false} />
    </>
  );
};

export default DeclarationAndSubmitPoi;